import React, { ReactElement, useEffect, useRef, useState } from 'react';
import logo from '../../assets/images/logo.svg';
import { useNavigate , useLocation } from "react-router-dom";
import Select from 'react-select'
import mark from '../../assets/images/mark.svg';
import occupationIcon from '../../assets/images/occupation.svg';
import AditionalDataService from "../../services/aditionalData.service";
import departamentData from '../../types/departament.type';
import aditionalData from '../../types/aditionalData.type';
import errorFace from '../../assets/images/errorFace.svg';
import Swal from 'sweetalert2';
import DocumentsService from "../../services/documents.service";
import { Wrapper, Status } from "@googlemaps/react-wrapper";
import NextButton from '../../components/ui/NextButton';
import { pageWard } from '../../utils/pageward';
import { sendEvent } from '../../utils/firebase';


const render = (status: Status): ReactElement => {
  if (status === Status.LOADING) return <h3>{status} ..</h3>;
  if (status === Status.FAILURE) return <h3>{status} ...</h3>;
  return <h3>{status} ....</h3>;
};

function AditionalData() {

  const navigate = useNavigate();
  const state = useLocation();

  useEffect(() => {
    sendEvent("INGRESA_A_DATOS_ADICIONALES");
  }, []);

  useEffect(() => {
    if (!pageWard("NEED_ADDITIONAL_DATA")) {
      navigate('/')
      return;
    };
  }, []);

  const [isDisabled, setIsDisabled] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [userName, setName] = useState("");
  const [position, setPosition] = useState({ lat: 0, lng:0 });

  const onClick = (e: google.maps.MapMouseEvent) => {
    setPosition(e.latLng.toJSON());
  };

  useEffect(() => {
    if (state.state) {
      setName(state.state.name);
    }
  }, []);

  useEffect(() => {
    DocumentsService.generateToken()
  }, []);

  useEffect(() => {
    setTimeout(() => {
      getOcupations();
    }, 1000);
  }, []);
  useEffect(() => {
    setTimeout(() => {
      getDepartaments();
    }, 1000);
  }, []);

  useEffect(() => {
    setIsActive(true);
    setTimeout(() => {
      setIsHiden(true);
    }, 1000);

  }, []);
    const [isActive, setIsActive] = useState(false);
    const [hideTransition, setIsHiden] = useState(false);
    const[occupationsData, setOccupations] = useState([{
      id: 0,
      description: "Selecciona tu ocupación",
      code: "Selecciona tu ocupación"
    }])
    const [occupation, setOccupationValue] = useState(0);
    const [validateOcc, setOcc] = useState(false);
    const [departament, setDepartamentValue] = useState(0);
    const[citiesData, setCities] = useState([{
      id: 0,
      description: "Selecciona tu ocupación",
      code: "Selecciona tu ocupación"
    }])
    const [validateDpto, setDpto] = useState(false);
    const [city, setCityValue] = useState(0);
    const [validateCity, setCityValid] = useState(false);
    const [address, setAddress] = useState("");
    const [validateAddress, setAddressValid] = useState(false);

    const [data, setData] = useState({
      occupations: [{
        id: 0,
        description: "Selecciona tu ocupación",
        code: "Selecciona tu ocupación"
      }],
      departaments: [],
      cities: [],
    });

    async function nextChallenge( ) {
      if(!occupation || occupation < 1) {
        setOcc(true);
      };
      if(!departament) {
        setDpto(true);
      };
      if(!city || city < 1) {
        setCityValid(true);
      };
      if(!address) {
        setAddressValid(true);
      };
      if(!occupation || occupation === 0 || !departament || !city || !address) {
        return;
      }
      setLoading(true);
      setIsDisabled(true);
      const aditionalData: aditionalData = {
        challengeName: "NEED_ADDITIONAL_DATA",
        termOfServiceRespond: "wally_1-0-0",
        sessionId: state.state.sessionId,
        securityProfileId: "P1-Web",
        additionalData: {
            departament: departament,
            city: city,
            address: address,
            occupation: occupation,
            geoLocation: {
                latitude: position.lat.toString(),
                longitude: position.lng.toString()
            }
        }
      }
    AditionalDataService.nextChallenge(aditionalData)
      .then((response: any) => {
        setLoading(false);
        setIsDisabled(false);
        sendEvent("FINALIZA_DATOS_ADICIONALES");
        localStorage.setItem('page', response.data.challengeName);
        if (response.data.challengeName === "DONE") {
          navigate("/bienvenido",{
            state: {
              sessionId: response.data.sessionId,
              name: response.data.enrollmentCustomer ? response.data.enrollmentCustomer.firstName : state.state.name,
              sex: response.data.enrollmentCustomer.sex 
            }
          });
        }
      })
      .catch((e: any) => {
        setLoading(false);
        setIsDisabled(false);
        Swal.fire({
          title: '¡Ooops!',
          text:e.response.data.message,
          imageUrl: errorFace,
          imageWidth: 150,
          imageHeight: 150,
          imageAlt: 'Custom image',
        })
      });
    }

    const selectStyle = {
      option: () => ({
        borderBottom: '0px',
        padding: 20,
        color: '#9ca3af',
      }),
      control: () => ({
        display: 'flex',
        color: '#9ca3af',
      }),
    }

  const getOcupations = () => {
    AditionalDataService.getOccupations()
    .then((response: any) => {
      setOccupations(response.data.occupations)
    })
    .catch((e: Error) => {
      console.log(e);
    });
  }

  const getDepartaments = () => {
    AditionalDataService.getDepartaments()
    .then((response: any) => {
      setData({
        ...data,
        departaments: response.data.departments,
      });
    })
    .catch((e: Error) => {
      console.log(e);
    });
  }
  
  const departaments =  data.departaments.map((departament: departamentData) => ({ value: departament, label: departament.description }));

  const SetDepartament = (e: any) => {
    setDepartamentValue(e.value.id);
    setCities(e.value.cities);
    setDpto(false)
    if(city) {
      setCityValue(0);
      setCityValid(true);
    };
  }
 
  const occupationChange = (event: { target: { value: any; }; }) => {
    setOccupationValue(event.target.value);
    setOcc(false)
  };
  const cityChange = (event: { target: { value: any; }; }) => {
    setCityValue(event.target.value);
    setCityValid(false);
  };

  const addressChange = (event: { target: { value: any; }; }) => {
    setAddress(event.target.value);
    setAddressValid(false);
  };
  return (
    <div className="dark:bg-bgDark h-full p-3 flex flex-col h-screen justify-between">
      <header className="w-full p-10">
        <img src={logo} className="h-12 mx-auto" alt="Wally" />
      </header>
      <div className={hideTransition ? 'transitionContainer hide' : 'transitionContainer'}>
        <div className={isActive ? 'transition show' : 'transition'}>
          <div className="layer one"></div>
          <div className="layer two"></div>
          <div className="layer three"></div>
        </div>
      </div>
      <div className="container mb-auto  max-w-md mx-auto ">
        <div className={hideTransition ? 'w-full mx-auto show' : 'w-full mx-auto'}>
          <h1 className="text-2xl text-wallyGray font-semibold dark:text-white">¡HOLA {userName}!</h1>
          <p className="text-gray-400 mt-2">Terminá tu registro completando estos datos adicionales.</p>
          <form action="">
            <div className="mt-6">
            <div className= {validateOcc ? 'shakeError w-full flex bg-gray-50 border border-red-400 rounded-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:outline-cyan-500 dark:focus:border-cyan-400' :'w-full flex bg-gray-50 border border-gray-300 rounded-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:outline-cyan-500 dark:focus:border-cyan-400'}>
                <div className="w-1/6">
                  <img src={occupationIcon} className="mx-auto h-5 mt-2" alt="Wally" />
                </div>
                <div className="w-5/6 ">
                  <select 
                    className="offCustomSelect bg-gray-50 text-xl p-1"
                    onChange={occupationChange}
                  >
                    <option value={0} >Ocupación</option>
                    {
                      occupationsData.map( occupation =>  {
                        return (        
                          <option value={occupation.id} key={occupation.id}>{occupation.description}</option>   
                        )
                        })
                      }
                  </select>
                </div>
              </div>
              {validateOcc? <p className="text-red-500 text-center text-sm mt-1">Seleccione una ocupación.</p> : null}
            </div>
            <div className={validateOcc? "mt-1" : "mt-6"}>
              <div className={validateDpto ? 'shakeError w-full flex bg-gray-50 border border-red-400 rounded-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:outline-cyan-500 dark:focus:border-cyan-400' :'w-full flex bg-gray-50 border border-gray-300 rounded-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:outline-cyan-500 dark:focus:border-cyan-400'}>
                <div className="w-1/6">
                  <img src={mark} className="mx-auto mt-1" alt="Wally" />
                </div>
                <div className="w-5/6 ">
                  <Select
                    className='offSelect text-xl dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:outline-cyan-500 dark:focus:border-cyan-400'
                    styles={selectStyle}
                    placeholder="Departamento"
                    isLoading={false}
                    options={departaments}
                    onChange={SetDepartament}
                  />
                </div>
              </div>
            </div>
            {validateDpto? <p className="text-red-500 text-center text-sm mt-1">Seleccione un departamento.</p> : null}
            <div className= {validateDpto? "mt-1" : "mt-6"}>
              <div className={validateCity ? 'shakeError w-full flex bg-gray-50 border border-red-400 rounded-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:outline-cyan-500 dark:focus:border-cyan-400' :'w-full flex bg-gray-50 border border-gray-300 rounded-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:outline-cyan-500 dark:focus:border-cyan-400'}>
                <div className="w-1/6">
                  <img src={mark} className="mx-auto mt-1" alt="Wally" />
                </div>
                <div className="w-5/6 ">
                  <select 
                    className="offCustomSelect bg-gray-50 text-xl p-1"
                    onChange={cityChange}
                  >
                    <option value={0}>Ciudad</option>
                    {
                      citiesData.map( city =>  {
                        return (        
                            <option key={city.id} value={city.id}>{city.description}</option>  
                        )
                        })
                      }
                  </select>
                </div>
              </div>
              {validateCity? <p className="text-red-500 text-center text-sm mt-1">Seleccione una ciudad.</p> : null}
            </div>
            <div className={validateCity? "mt-1" : "mt-6"}>
              <div className="relative" >
                <div className="flex absolute inset-y-0 mt-1 left-5 items-center pl-2 pointer-events-none">
                  <img src={mark} className="mx-auto mb-1" alt="Wally" />
                </div>
                <input
                    onChange={addressChange}
                    className={validateAddress ? "shakeError w-full placeholder-gray-500 bg-gray-50 border border-red-400 text-gray-900 text-xl rounded-full focus:outline-cyan-500 focus:border-cyan-400 block  pl-20 p-3 pb-4 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:outline-cyan-500 dark:focus:border-cyan-400": "w-full placeholder-gray-500 bg-gray-50 border border-gray-300 text-gray-900 text-xl rounded-full focus:outline-cyan-500 focus:border-cyan-400 block  pl-20 p-3 pb-4 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:outline-cyan-500 dark:focus:border-cyan-400 forceGray"}
                    placeholder="Dirección"
                />
              </div>
              {validateAddress? <p className="text-red-500 text-center text-sm mt-1">Ingrese su dirección.</p> : null}
            </div>
            <div className = "mt-6">
            <p className="text-gray-500 mt-2 mb-2">Haz click en tu ubicación para agregar el marcador.</p>
            <Wrapper apiKey="AIzaSyCk1wdrXStBiwb3jMQjEe50CfGHvtsfh2I"  render={render}>
              <Map
                onClick={onClick}
                style={{ height: "300px", width: "100%" }}
              >
               <Marker position={position} />
              </Map>
            </Wrapper>
            </div>
          </form>
        </div>
      </div>
        <div className="container  max-w-md mx-auto ">
            <div className="relative pb-20 text-center w-full">
                <NextButton
                name="FINALIZAR"
                onClick={nextChallenge}
                isDisabled={isDisabled}
                loading ={isLoading}
              />
            </div>
        </div>
    </div>
  );
}

interface MapProps extends google.maps.MapOptions {
  style: { [key: string]: string };
  onClick?: (e: google.maps.MapMouseEvent) => void;
  onIdle?: (map: google.maps.Map) => void;
  children?: React.ReactNode;
}

const Map: React.FC<MapProps> = ({
  style,
  onClick,
  children
}) => {

  const ref = useRef<HTMLDivElement>(null);
  const [map, setMap] = React.useState<google.maps.Map>();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const center = { lat: -25.256898630281388, lng: -57.578819186896965 };
  const zoom = 15;
  
  useEffect(() => {
    if (ref.current && !map) {
      setMap(new window.google.maps.Map(ref.current, {
        center: center,
        zoom: zoom,
      }));
    }
  }, [ref, map, center]);


  useEffect(() => {
    if (map) {
      ["click", "idle"].forEach((eventName) =>
        google.maps.event.clearListeners(map, eventName)
      );
      if (onClick) {
        map.addListener("click", onClick);
      }
    }
  }, [map, onClick]);

  return (
    <>
      <div ref={ref} style={style} id="map" />
      {React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
          // @ts-ignore
          return React.cloneElement(child, { map });
        }
      })}
    </>
  );
};
const Marker: React.FC<google.maps.MarkerOptions> = (options) => {
  const [marker, setMarker] = React.useState<google.maps.Marker>();

  React.useEffect(() => {
    if (!marker) {
      setMarker(new google.maps.Marker());
    }
    return () => {
      if (marker) {
        marker.setMap(null);
      }
    };
  }, [marker]);

  React.useEffect(() => {
    if (marker) {
      marker.setOptions(options);
    }
  }, [marker, options]);

  return null;
};


export default AditionalData;